const updateSmsAvailability = require("./updateSmsAvailability");
const PreferenceCenter_refreshPrivacyPolicy = require("./PreferenceCenter_refreshPrivacyPolicy");
const getPreferenceCenterCountrySelect = require("./getPreferenceCenterCountrySelect");
const When_CountrySelect_changes = require("../../When_CountrySelect_changes");

/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = function whenPreferenceCenterCountrySelectChange(preferenceCenter) {
    updateSmsAvailability(preferenceCenter);

    const countrySelect = getPreferenceCenterCountrySelect(preferenceCenter);
    When_CountrySelect_changes(countrySelect);

    PreferenceCenter_refreshPrivacyPolicy(preferenceCenter);
}
